<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Copyright-rw exclude-print-rw page-open-auto-rw" epub:type="frontmatter copyright-page" id="Copyright1">
<div class="block-rw copyright-rw" id="copyright3">
<p class="crt-rw" id="p2703"><span>This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.</span></p>
<p class="crt-rw" id="p2704"><span>Copyright © 2017 by Heidi McLaughlin<br/>
Teaser from <i>Third Base </i>Copyright © 2016 by Heidi McLaughlin</span></p>
<p class="crt-rw" id="p2705"><span>Cover design by Elizabeth Turner. Cover copyright © 2017 by Hachette Book Group, Inc.</span></p>
<p class="crt-rw" id="p2706"><span>Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.</span></p>
<p class="crt-rw" id="p2707"><span>The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.</span></p>
<p class="crt-rw" id="p2708"><span>Forever<br/>
Hachette Book Group<br/>
1290 Avenue of the Americas<br/>
New York, NY 10104<br/><a href="http://forever-romance.com" target="_blank">forever-romance.com</a><br/><a href="http://twitter.com/foreverromance" target="_blank">twitter.com/foreverromance</a></span></p>
<p class="crt-rw" id="p2709"><span>Originally published in ebook by Forever in May 2017.</span></p>
<p class="crt-rw" id="p2710"><span>First Trade Edition: August 2017</span></p>
<p class="crt-rw" id="p2711"><span>Forever is an imprint of Grand Central Publishing.<br/>
The Forever name and logo are trademarks of Hachette Book Group, Inc.</span></p>
<p class="crt-rw" id="p2712"><span>The publisher is not responsible for websites (or their content) that are not owned by the publisher.</span></p>
<p class="crt-rw" id="p2713"><span>The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to www.hachettespeakersbureau.com or call (866) 376-6591.</span></p>
<p class="crt-rw" id="p2714"><span>Library of Congress Cataloging-in-Publication Data<br/><br/>
Names: McLaughlin, Heidi (Romance fiction writer) author.<br/>
Title: Grand slam / Heidi McLaughlin.<br/>
Description: First Trade Edition. | New York ; Boston : Forever, 2017. |<br/>
Series: The boys of summer ; 3<br/>
Identifiers: LCCN 2017008726| ISBN 9781455598311 (paperback) | ISBN<br/>
9781455598304 (ebook) | ISBN 9781478975274 (audio download)<br/>
Subjects: LCSH: Man-woman relationships--Fiction. | Baseball<br/>
players--Fiction. | BISAC: FICTION / Romance / Contemporary. | FICTION /<br/>
Contemporary Women. | GSAFD: Love stories.<br/>
Classification: LCC PS3613.C57535 G73 2017 | DDC 813/.6--dc23<br/>
LC record available at <span class="Internetlink">https://lccn.loc.gov/2017008726</span></span></p>
<p class="crt-rw" id="p2715"><span>ISBN: 978-1-4555-9831-1 (trade pbk.), 978-1-4555-9830-4 (ebook)</span></p>
<p class="crt-rw" id="p2716"><span>E3-20170410-DA-NF</span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s002-Copyright-01.vue?c80b018e